/* KATHAKAR theme script. One passive scroll loop, no dependencies. */
(() => {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const FINE = matchMedia('(hover: hover) and (pointer: fine)').matches;
  const root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
  document.documentElement.classList.remove('no-js');

  /* Toast */
  const toastEl = $('#Toast');
  let toastT;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(() => toastEl.classList.remove('is-on'), 2800);
  }

  /* Scroll loop: header mode + Turn sections */
  const hdr = $('.hdr');
  let turns = [];
  let ticking = false;
  function themedSections() { return $$('[data-theme]').filter(el => !el.closest('.hdr-wrap') && !el.closest('.drawer')); }
  let themed = themedSections();
  function update() {
    ticking = false;
    if (hdr) {
      const y = hdr.getBoundingClientRect().bottom + 1;
      for (const s of themed) {
        const b = s.getBoundingClientRect();
        if (b.top <= y && b.bottom > y) { hdr.dataset.mode = s.dataset.theme; break; }
      }
    }
    const vh = innerHeight;
    turns.forEach(t => {
      const r = t.el.getBoundingClientRect();
      if (r.bottom < -vh || r.top > vh * 2) return;
      const total = Math.max(1, t.el.offsetHeight - vh);
      const p = Math.min(1, Math.max(0, -r.top / total));
      const q = Math.min(1, Math.max(0, (p - 0.2) / 0.55));
      const s = q * q * (3 - 2 * q);
      const v = s.toFixed(4);
      t.el.dataset.p = v;
      if (t.flip) t.flip.style.setProperty('--p', v);
      t.el.classList.toggle('is-back', s > 0.5);
      t.el.dataset.rest = s < 0.04 ? 'front' : s > 0.96 ? 'back' : '';
      if (t.sw) t.sw.setAttribute('aria-checked', s > 0.5 ? 'true' : 'false');
    });
  }
  const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };

  /* The Turn: the switch and the big words scroll to the side you asked for */
  document.addEventListener('click', e => {
    const go = e.target.closest('[data-turn-go], [data-turn-switch]');
    const sec = go && go.closest('.turn');
    if (!sec) return;
    const side = go.dataset.turnGo || (sec.classList.contains('is-back') ? 'front' : 'back');
    const total = Math.max(1, sec.offsetHeight - innerHeight);
    const top = sec.getBoundingClientRect().top + scrollY;
    scrollTo({ top: top + total * (side === 'back' ? 0.86 : 0.08), behavior: RM ? 'auto' : 'smooth' });
  });
  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onScroll);

  function initTurns() {
    turns = $$('.turn').map(el => ({ el, flip: $('.flip', el), sw: $('[data-turn-switch]', el) }));
    themed = themedSections();
    update();
  }

  /* Streetlight glow on night sections (desktop pointer only) */
  function initLamps(scope = document) {
    if (RM || !FINE) return;
    $$('[data-lamp]', scope).forEach(sec => {
      if (sec.dataset.lampOn) return;
      sec.dataset.lampOn = '1';
      sec.addEventListener('pointermove', e => {
        const b = sec.getBoundingClientRect();
        sec.style.setProperty('--mx', (e.clientX - b.left) + 'px');
        sec.style.setProperty('--my', (e.clientY - b.top) + 'px');
      });
    });
  }

  /* Reveal on scroll */
  const io = 'IntersectionObserver' in window ? new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
  }), { rootMargin: '0px 0px -8% 0px' }) : null;
  function initReveal(scope = document) {
    $$('.rv:not(.in)', scope).forEach(el => io ? io.observe(el) : el.classList.add('in'));
  }

  /* Pause button on marquee bands: stops all endless motion (bands + stamp) via .is-still on <html> */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-motion-toggle]');
    if (!b) return;
    const on = document.documentElement.classList.toggle('is-still');
    $$('[data-motion-toggle]').forEach(t => t.setAttribute('aria-pressed', String(on)));
  });

  /* Card flip (touch) */
  document.addEventListener('click', e => {
    const b = e.target.closest('.card__flip');
    if (!b) return;
    e.preventDefault();
    const card = b.closest('.card');
    const on = card.classList.toggle('is-flipped');
    b.setAttribute('aria-pressed', String(on));
  });

  /* Lane chips filter (featured section) */
  document.addEventListener('click', e => {
    const chip = e.target.closest('[data-filter]');
    if (!chip) return;
    const sec = chip.closest('[data-filter-scope]');
    if (!sec) return;
    e.preventDefault();
    const lane = chip.dataset.filter;
    $$('[data-filter]', sec).forEach(c => c.setAttribute('aria-pressed', String(c === chip)));
    let shown = 0;
    $$('.card', sec).forEach(c => {
      const lanes = (c.dataset.lanes || '').split(' ');
      const on = lane === 'all' || lanes.includes(lane);
      c.classList.toggle('is-hidden', !on);
      if (on) shown++;
    });
    const empty = $('[data-filter-empty]', sec);
    if (empty) empty.hidden = shown > 0;
  });

  /* Drawers */
  const scrim = $('#Scrim');
  let openDrawer = null, lastFocus = null;
  /* While a drawer is open, everything around it is inert, so Tab and screen readers stay inside it */
  let walled = [];
  function wallOff(d) {
    for (let el = d; el.parentElement && el !== document.body; el = el.parentElement) {
      for (const sib of el.parentElement.children) {
        if (sib === el || sib === scrim || sib === toastEl || sib.inert || /^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(sib.tagName)) continue;
        sib.inert = true;
        walled.push(sib);
      }
    }
  }
  function unwall() { walled.forEach(el => { el.inert = false; }); walled = []; }
  function open(d) {
    if (!d) return;
    if (openDrawer && openDrawer !== d) close(openDrawer, false);
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.removeAttribute('inert');
    d.setAttribute('aria-hidden', 'false');
    wallOff(d);
    scrim && scrim.classList.add('is-open');
    document.body.classList.add('is-locked');
    openDrawer = d;
    const f = $('[data-autofocus], button, a, input', d);
    f && setTimeout(() => f.focus({ preventScroll: true }), 60);
  }
  function close(d = openDrawer, restore = true) {
    if (!d) return;
    unwall();
    d.classList.remove('is-open');
    d.setAttribute('inert', '');
    d.setAttribute('aria-hidden', 'true');
    scrim && scrim.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    openDrawer = null;
    if (restore && lastFocus) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('click', e => {
    const o = e.target.closest('[data-open]');
    if (o) { e.preventDefault(); open(document.getElementById(o.dataset.open)); return; }
    if (e.target.closest('[data-close]') || e.target === scrim) { e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && openDrawer) close(); });

  /* Dialogs (size guide) */
  document.addEventListener('click', e => {
    const o = e.target.closest('[data-dialog]');
    if (o) {
      const dlg = document.getElementById(o.dataset.dialog);
      if (dlg && dlg.showModal) {
        const sel = $('input[data-size-option]:checked');
        $$('tr[data-size]', dlg).forEach(tr => tr.classList.toggle('is-active', !!sel && tr.dataset.size === sel.value));
        dlg.showModal();
      }
      return;
    }
    const c = e.target.closest('[data-dialog-close]');
    if (c) c.closest('dialog').close();
    if (e.target.tagName === 'DIALOG') e.target.close();
  });

  /* Cart */
  const cartDrawer = $('#CartDrawer');
  function setCount(n) { $$('[data-cart-count]').forEach(el => { el.textContent = n > 0 ? n : ''; el.dataset.count = n; }); }
  function swapDrawer(html) {
    if (!html || !cartDrawer) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const inner = $('.js-cart-inner', doc);
    const cur = $('.js-cart-inner', cartDrawer);
    if (inner && cur) {
      cur.replaceWith(inner);
      setCount(parseInt(inner.dataset.count || '0', 10));
    }
  }
  async function refreshCart() {
    const r = await fetch(root + '?sections=cart-drawer');
    const j = await r.json();
    swapDrawer(j['cart-drawer']);
  }
  async function cartChange(line, quantity) {
    const r = await fetch(root + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity, sections: ['cart-drawer'] })
    });
    const j = await r.json();
    if (!r.ok) { toast(j.description || j.message || 'That didn’t work. Try again.'); return; }
    swapDrawer(j.sections && j.sections['cart-drawer']);
    if (document.body.dataset.template === 'cart') location.reload();
  }
  document.addEventListener('click', e => {
    const q = e.target.closest('[data-qty]');
    if (q) {
      e.preventDefault();
      const line = parseInt(q.dataset.line, 10);
      const cur = parseInt(q.dataset.current, 10);
      cartChange(line, Math.max(0, cur + parseInt(q.dataset.qty, 10)));
      return;
    }
    const rm = e.target.closest('[data-remove]');
    if (rm) { e.preventDefault(); cartChange(parseInt(rm.dataset.line, 10), 0); }
  });
  document.addEventListener('submit', async e => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form || !cartDrawer) return;
    e.preventDefault();
    const btn = $('[type=submit]', form);
    const err = form.dataset.error ? document.getElementById(form.dataset.error) : null;
    const idInput = $('input[name=id]', form);
    if (idInput && !idInput.value) {
      if (err) err.textContent = form.dataset.chooseMsg || 'Pick a size first.';
      const first = $('input[data-size-option]');
      first && first.focus();
      return;
    }
    btn && btn.classList.add('is-loading');
    try {
      const fd = new FormData(form);
      fd.append('sections', 'cart-drawer');
      fd.append('sections_url', location.pathname);
      const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
      const j = await r.json();
      if (!r.ok || j.status) {
        if (err) err.textContent = j.description || 'Couldn’t add this to your bag. Try again.';
        return;
      }
      if (err) err.textContent = '';
      swapDrawer(j.sections && j.sections['cart-drawer']);
      open(cartDrawer);
    } catch (x) {
      if (err) err.textContent = 'Couldn’t reach the store. Check your connection and try again.';
    } finally {
      btn && btn.classList.remove('is-loading');
    }
  });

  /* Product: variant picker */
  function initProduct(scope = document) {
    $$('[data-product-root]', scope).forEach(rootEl => {
      if (rootEl.dataset.ready) return;
      rootEl.dataset.ready = '1';
      const dataEl = $('script[data-product-json]', rootEl);
      if (!dataEl) return;
      const product = JSON.parse(dataEl.textContent);
      const form = $('form[data-ajax-cart]', rootEl);
      const idInput = form && $('input[name=id]', form);
      const priceEls = $$('[data-price]', document);
      const compareEls = $$('[data-compare]', document);
      const btns = $$('[data-buy-label]', document);
      const fieldsets = $$('[data-option-index]', rootEl);
      const retired = rootEl.dataset.retired === 'true';
      const err = form && form.dataset.error ? document.getElementById(form.dataset.error) : null;
      const money = cents => {
        const n = cents / 100;
        return '₹' + n.toLocaleString('en-IN', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
      };
      function selected() {
        return fieldsets.map(fs => { const c = $('input:checked', fs); return c ? c.value : null; });
      }
      function render() {
        const sel = selected();
        const complete = sel.every(v => v !== null);
        const variant = !fieldsets.length ? product.variants[0]
          : complete ? product.variants.find(v => v.options.every((o, i) => o === sel[i])) : null;
        fieldsets.forEach((fs, i) => {
          const lbl = $('[data-selected-value]', fs);
          if (lbl) lbl.textContent = sel[i] ? ': ' + sel[i] : '';
          $$('input', fs).forEach(inp => {
            const ok = product.variants.some(v => v.available && v.options[i] === inp.value && v.options.every((o, j) => j === i || sel[j] === null || o === sel[j]));
            inp.classList.toggle('is-unavailable', !ok);
          });
        });
        if (idInput) idInput.value = variant ? variant.id : '';
        const showPrice = variant ? variant.price : product.price;
        priceEls.forEach(el => { el.textContent = money(showPrice); });
        compareEls.forEach(el => {
          const c = variant && variant.compare_at_price > variant.price ? variant.compare_at_price : 0;
          el.textContent = c ? money(c) : '';
          el.hidden = !c;
        });
        btns.forEach(b => {
          const base = b.dataset.buyLabel;
          if (retired) { b.disabled = true; b.textContent = b.dataset.retiredLabel; return; }
          if (variant && !variant.available) { b.disabled = true; b.textContent = b.dataset.soldLabel; return; }
          b.disabled = false;
          b.textContent = base + ' · ' + money(showPrice);
        });
        if (variant) {
          if (err) err.textContent = '';
          const url = new URL(location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState(null, '', url);
        }
      }
      fieldsets.forEach(fs => fs.addEventListener('change', render));
      render();

      /* Sticky buy bar */
      const sticky = $('[data-sticky-buy]');
      const mainBtn = form && $('[type=submit]', form);
      if (sticky && mainBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(([e]) => {
          const below = e.boundingClientRect.top < 0;
          sticky.classList.toggle('is-on', !e.isIntersecting && below);
        }).observe(mainBtn);
        const sb = $('button', sticky);
        sb && sb.addEventListener('click', () => {
          if (idInput && idInput.value) form.requestSubmit ? form.requestSubmit() : form.submit();
          else { mainBtn.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'center' }); if (err) err.textContent = form.dataset.chooseMsg; }
        });
      }
    });

    /* Gallery turn: drag or press to turn the tee */
    $$('.gal__turn', scope).forEach(stage => {
      if (stage.dataset.ready) return;
      stage.dataset.ready = '1';
      const flip = $('.flip', stage);
      const btn = $('[data-turn]', stage);
      const label = $('[data-turn-label]', stage);
      let rot = stage.classList.contains('is-back') ? 180 : 0;
      let drag = null;
      const setR = (v, anim = true) => { rot = v; stage.dataset.r = rot; flip.style.transition = anim ? '' : 'none'; flip.style.setProperty('--r', rot + 'deg'); };
      const settle = () => {
        const s = Math.round(rot / 180) * 180;
        setR(s);
        const back = ((s % 360) + 360) % 360 === 180;
        stage.classList.toggle('is-back', back);
        if (btn) btn.setAttribute('aria-pressed', String(back));
        if (label) label.textContent = back ? label.dataset.back : label.dataset.front;
      };
      setR(rot, false);
      btn && btn.addEventListener('click', e => { e.stopPropagation(); setR(Math.round(rot / 180) * 180 + 180); settle(); });
      if (!RM) {
        stage.addEventListener('pointerdown', e => {
          if (e.target.closest('button')) return;
          drag = { x: e.clientX, r: rot, moved: false };
          stage.setPointerCapture(e.pointerId);
        });
        stage.addEventListener('pointermove', e => {
          if (!drag) return;
          const dx = e.clientX - drag.x;
          if (Math.abs(dx) > 4) drag.moved = true;
          setR(drag.r + dx * 0.6, false);
        });
        const end = () => { if (drag) { drag = null; settle(); } };
        stage.addEventListener('pointerup', end);
        stage.addEventListener('pointercancel', end);
      }
    });
  }

  /* Collection sort */
  document.addEventListener('change', e => {
    const s = e.target.closest('[data-sort]');
    if (!s) return;
    const url = new URL(location.href);
    url.searchParams.set('sort_by', s.value);
    url.searchParams.delete('page');
    location.href = url.toString();
  });

  /* Newsletter / contact success toast */
  if (location.search.includes('customer_posted=true')) toast('You’re on the list. We’ll write when the next katha drops.');

  function initAll(scope = document) {
    initLamps(scope);
    initReveal(scope);
    initProduct(scope);
    initTurns();
  }
  initAll();
  document.addEventListener('shopify:section:load', e => initAll(e.target));
  document.addEventListener('shopify:section:unload', () => setTimeout(initTurns, 0));
  window.Kathakar = { toast, refreshCart, open, close };
})();
